module.exports = __webpack_public_path__ + "static/media/2016.9115f1cf.png";